import React, { useMemo, useState } from "react";
import { t } from "i18next";
import { BuilderToolbarMenuSubViewList } from "components/builderShell/BuilderToolbarMenuSubViewList";
import { ThemesView } from "./themes/ThemesView";
import { ColorsView } from "./colors/ColorsView";
import { FontsView } from "./fonts/FontsView";
import { WebsiteBuilderToolbarMenuView } from "../../WebsiteBuilderToolbarMenuView";

type TDesignViewSubViewType = "themes" | "colors" | "fonts" | "none";

interface IDesignViewSubViewOption {
  type: TDesignViewSubViewType;
  title: string;
}

export function DesignView() {
  const [subViewType, setSubViewType] = useState<TDesignViewSubViewType>("none");

  const subViewOptions: IDesignViewSubViewOption[] = useMemo(
    () => [
      { type: "themes", title: t("Themes") },
      { type: "colors", title: t("Colors") },
      { type: "fonts", title: t("Fonts") },
    ],
    [],
  );

  function goBackToDesignView() {
    setSubViewType("none");
  }

  function renderDesignView() {
    switch (subViewType) {
      case "themes":
        return <ThemesView goBackToParentView={goBackToDesignView} />;
      case "colors":
        return <ColorsView goBackToParentView={goBackToDesignView} />;
      case "fonts":
        return <FontsView goBackToParentView={goBackToDesignView} />;
      case "none":
      default:
        return (
          <WebsiteBuilderToolbarMenuView
            title={t("Design")}
            noSectionsPadding
            sections={[
              {
                content: (
                  <BuilderToolbarMenuSubViewList
                    options={subViewOptions.map(option => ({
                      id: option.type,
                      title: option.title,
                    }))}
                    onSelect={id => setSubViewType(id)}
                  />
                ),
              },
            ]}
          />
        );
    }
  }

  return renderDesignView();
}
